import { render } from "./Fotos.vue?vue&type=template&id=73645892"
const script = {}

import "./Fotos.vue?vue&type=style&index=0&id=73645892&lang=scss"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\andremudancasemgeral\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__